export default __webpack_public_path__ + "static/media/icon_transaction-reports.5d53bccb.svg";